import React from "react";
import { PREP_RULES, PREP_IMAGE } from "@/content/veguk";
import { PREP } from "@/constants/testIds";
import {
  Utensils,
  Droplets,
  Flame,
  HandPlatter,
  ShieldCheck,
  BadgeCheck,
} from "lucide-react";

const ICONS = [Utensils, Droplets, Flame, HandPlatter, ShieldCheck, BadgeCheck];

export const FoodPrep = () => {
  return (
    <section
      id="prep"
      data-testid={PREP.root}
      className="py-24 lg:py-32 bg-[#EAE3D9]/40"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-5">
          <span className="veg-overline">Preparation & serving</span>
          <h2 className="font-serif-display mt-4 text-4xl sm:text-5xl text-[#2E5C46] leading-[1.05]">
            Six requirements every kitchen must respect.
          </h2>
          <p className="mt-6 text-[#4A5D4E] leading-relaxed">
            Whether you serve a hospital ward, a school dining hall, an airline cabin
            or a community kitchen, these rules safeguard vegetarian diners and uphold
            the integrity of every type.
          </p>
          <div className="mt-8 relative overflow-hidden rounded-lg border border-[#D1C9B9]">
            <img
              src={PREP_IMAGE}
              alt="Grains, pulses and spices arranged on a kitchen surface"
              className="w-full h-72 object-cover"
            />
          </div>
        </div>

        <div className="lg:col-span-7 grid sm:grid-cols-2 gap-5">
          {PREP_RULES.map((rule, i) => {
            const Icon = ICONS[i] || ShieldCheck;
            return (
              <article
                key={rule.title}
                data-testid={PREP.item(i)}
                className="veg-card-hover rounded-lg p-7 bg-white border border-[#D1C9B9]"
              >
                <div className="flex items-center justify-between mb-5">
                  <Icon size={22} className="text-[#2E5C46]" />
                  <span className="font-serif-display text-2xl text-[#2E5C46]/60">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <h3 className="font-serif-display text-2xl text-[#2C352D] leading-snug">
                  {rule.title}
                </h3>
                <p className="mt-3 text-sm text-[#4A5D4E] leading-relaxed">
                  {rule.body}
                </p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};
